import { createURLQuery } from './api/apiUtil.js';

var DEFAULT_IMAGE_FORMAT = "webp";
var DEFAULT_IMAGE_QUALITY = 85;
var checkWebpFeature = function checkWebpFeature() {
  return new Promise(function (resolve) {
    var img = new Image();
    img.onerror = function () {
      return resolve(false);
    };
    img.onload = function () {
      return resolve(img.width > 0 && img.height > 0);
    };
    img.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
  })["catch"](function () {
    return false;
  });
};
var contentfulImageApi = function () {
  var webpSupport = null;
  if (webpSupport === null) {
    checkWebpFeature().then(function (result) {
      webpSupport = result;
    });
  }
  return {
    retrieveImage: function retrieveImage(url, sizeOptions, formatOptions, manipulationOptions) {
      var format = (formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.format) || DEFAULT_IMAGE_FORMAT;
      if (format === "webp" && webpSupport === false) {
        format = "jpg";
      }
      var queryParams = {
        w: Math.round(sizeOptions === null || sizeOptions === void 0 ? void 0 : sizeOptions.width) || null,
        h: Math.round(sizeOptions === null || sizeOptions === void 0 ? void 0 : sizeOptions.height) || null,
        fit: (sizeOptions === null || sizeOptions === void 0 ? void 0 : sizeOptions.fit) || null,
        f: (sizeOptions === null || sizeOptions === void 0 ? void 0 : sizeOptions.focus) || null,
        fm: format,
        fl: formatOptions !== null && formatOptions !== void 0 && formatOptions.fl && (format === "jpg" && (formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.fl) === "progressive" || format === "png" && (formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.fl) === "png8") ? formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.fl : null,
        q: (manipulationOptions === null || manipulationOptions === void 0 ? void 0 : manipulationOptions.quality) || DEFAULT_IMAGE_QUALITY,
        bg: (manipulationOptions === null || manipulationOptions === void 0 ? void 0 : manipulationOptions.background) || null
      };
      return url + createURLQuery(queryParams);
    }
  };
}();
var retrieveContentfulImage = contentfulImageApi.retrieveImage;

export { checkWebpFeature, retrieveContentfulImage };
//# sourceMappingURL=image.js.map
